<template>
    <div>
        <div class="video-container1">
            <video class="filter-video banner-video" autoplay loop muted playsinline>
                <source src="assets/images/background.mp4" type="video/mp4">
                Seu navegador não suporta o elemento de vídeo.
            </video>
        </div>
        <div class="my-app service-app">

            <!-- ==== / preloader end ==== -->
            <!-- ==== mouse cursor drag start ==== -->
            <div class="mouseCursor cursor-outer"></div>
            <div class="mouseCursor cursor-inner">
                <span>Drag</span>
            </div>
            <!-- ==== / mouse cursor drag end ==== -->
            <div id="smooth-wrapper">
                <div id="smooth-content">
                    <!-- ==== main start ==== -->
                    <main class="authentication" data-background="assets/images/auth-line.png">
                        <section class="authentication-wrapper">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12 col-md-8 col-lg-6 col-xl-4">
                                        <div class="authentication__content section">
                                            <div class="intro">
                                                <h2 style="font-size: 40px;" class="light-title-sm title-animation fw-7 text-white mt-12">Acessar Painel</h2>
                                                <p>Bem vindo!</p>
                                            </div>
                                            <div class="authentication__inner">
                                                <form action="#" method="post">
                                                    <div class="input-single">
                                                        <label for="userName">Email</label>
                                                        <div class="ic-group">
                                                            <input type="text"
                                                                   name="user-name"
                                                                   id="userName"
                                                                   placeholder="Digite seu Email"
                                                                   v-model="user.login"
                                                                   required>
                                                            <span class="material-symbols-outlined">
                                                                person
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="input-single">
                                                        <label for="userPassword">Senha</label>
                                                        <div class="ic-group pass">
                                                            <span class="material-symbols-outlined show-pass" @click="passwordField = !passwordField">
                                                                <template v-if="passwordField">
                                                                    visibility_off
                                                                </template>
                                                                <template v-else>
                                                                    visibility
                                                                </template>
                                                            </span>
                                                            <input :type="(passwordField?'password':'text')"
                                                                   name="user-Password"
                                                                   id="userPassword"
                                                                   placeholder="Digite sua Senha"
                                                                   v-model="user.password" v-on:keyup.enter="entrar"
                                                                   required>
                                                            <span class="material-symbols-outlined" @click="toglePassword">
                                                                key
                                                            </span>
                                                        </div>
                                                        <a href="javascript:void(0)" @click=" showModal = !showModal">Esqueci minha senha</a>
                                                    </div>
                                                    <div class="section__content-cta">
                                                        <button type="button" @click="entrar" class="btn btn--primary">Entrar</button>
                                                    </div>
                                                </form>
                                            </div>
                                            <div class="auth-footer">
                                                <p>
                                                    Se você ainda não possui uma conta, por favor, solicite uma agora.
                                                    <a href="javascript:void(0)" @click="showExperimenteGratis = !showExperimenteGratis">Solicite!</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </main>
                    <!-- ==== / main end ==== -->
                </div>
            </div>
            <!-- ==== scroll to top start ==== -->
            <button class="progress-wrap" aria-label="scroll indicator" title="go to top">
                <span></span>
                <svg class="progress-circle svg-content"
                     width="100%"
                     height="100%"
                     viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
                </svg>
            </button>
            <!-- ==== / scroll to top end ==== -->
            <EsqueciMinhaSenha :showModal="showModal"></EsqueciMinhaSenha>
            <ExperimenteGratis :showModal="showExperimenteGratis"></ExperimenteGratis>
        </div>
    </div>
   
</template>

<script>
    import $ from 'jquery'
    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import EsqueciMinhaSenha from '@/components/EsqueciMinhaSenha'
    import ExperimenteGratis from '@/components/ExperimenteGratis'

    export default {
        name: 'Login',
        components: { EsqueciMinhaSenha, ExperimenteGratis },
        data() {
            return {
                user: {
                    login: "",
                    password: "",
                    //idModulo: idModulo,
                },
                showModal: false,
                showExperimenteGratis: false,

                passwordField: true,
            }
        },
        methods: {
            entrar(event) {
                event.preventDefault();
                if (this.checkForm()) {
                    //var loading = this.$loading.show({});
                    let $this = this;
                    axios.post(`${urlApi}/Auth/signin`, this.user)
                        .then(res => {
                            if (res.data.token.authenticated) {
                                res.data.token.usuario = res.data.usuario;
                                res.data.token.usuario.idContrato = res.data.idContrato;
                                res.data.token.usuario.tpPessoa = res.data.tpPessoa;
                                res.data.token.usuario.flCortesia = res.data.flCortesia;
                                res.data.token.usuario.isAdmContrato = res.data.isAdmContrato;

                                $this.$store.commit('setUser', res.data.token)
                                $this.$router.push({ name: 'Home' });
                            } else {
                                avisoErro("Erro ao realizar login.");
                            }
                            //loading.hide();
                        })
                        .catch(function () {
                            avisoErro("Login e/ou senha inválidos.");
                            //avisoErro(res.response.statusText);
                            //loading.hide();
                        })
                }

                return false;
            },


            checkForm() {
                var form = document.querySelector('form')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            autoatendimento() {
                document.getElementById('blip-chat-icon').click();
            },

            toglePassword() {
                var passwordField = $(".input-single").next("input");
                if (passwordField.attr("type") === "password") {
                    passwordField.attr("type", "text");
                    $(this).text("visibility");
                } else {
                    passwordField.attr("type", "password");
                    $(this).text("visibility_off");
                }
            },
        },
        created(){
            
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .input-single a {
        color: #686673 !important;
    }
</style>

